import each from "lodash-es/each";
import find from "lodash-es/find";
import kebabCase from "lodash-es/kebabCase";
import uniqueId from "lodash-es/uniqueId";
import { SurveyQuestion } from "./survey-models";

export class SurveySection {
  name: string;
  focused: boolean;
  order: number;
  questions: SurveyQuestion[] = [];
  headerIdRef: string;

  static fromApiV2(response): SurveySection {
    const section = new SurveySection();
    section.name = response.header;
    section.order = response.order;
    section.headerIdRef = kebabCase(section.name) + "-header-" + uniqueId();

    each(response.questions, question => {
      section.questions.push(SurveyQuestion.fromApiV2(question));
    });

    return section;
  }

  isSectionActivated() {
    return find(this.questions, (question: any) => {
      return question.activated;
    });
  }

  setFocus() {
    this.focused = true;
  }
}
